import { Heading } from '@backend/lib-design-system';
import { styled } from 'styled-components';

import { Column } from '~/components/Column';
import { Container } from '~/components/Container/Container';
import { Row } from '~/components/Row';
import { palette } from '~/themes/default';
import { getMediaQuery } from '~/utils/responsive/media';

export const StyledHeader = styled(Container)`
  background: linear-gradient(${palette.darkBlue}, ${palette.darkerBlue});
`;

export const StyledHeaderMainContainer = styled(Row)`
  align-items: center;
`;

export const StyledHeaderContainer = styled(Column)`
  flex: 1;
  width: 0;

  ${getMediaQuery('desktop', 'laptop')} {
    max-width: 46rem;
  }
`;

export const StyledHeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderTitle = styled(Heading)`
  flex: 1;
  width: 0;

  color: white;
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  font-size: 4rem;
  line-height: 4rem;

  ${getMediaQuery('mobile')} {
    font-size: 3rem;
    line-height: 3rem;
    text-align: center;
  }

  > span {
    color: ${({ theme }) => theme.colors.accent?.normal};
  }
`;

export const HeaderFrontImageDesktop = styled.div`
  flex: 0 0 350px;

  img {
    width: 100%;
    height: auto;
  }

  ${getMediaQuery('mobile', 'tablet', 'laptop')} {
    display: none;
  }
`;

export const HeaderFrontImageTablet = styled.div`
  flex: 0 0 300px;

  img {
    width: 100%;
    height: auto;
  }

  ${getMediaQuery('mobile', 'desktop', 'laptop')} {
    display: none;
  }
`;
